<article class="content">
  <h1>Privacy Policy</h1>
  <p>Last updated: July 3, 2025</p>

  <p>
    Welcome to Pink Soul ("we", "our", or "us"). Your privacy is important to
    us. This Privacy Policy explains how we collect, use, and protect your
    personal information when you use our website
    <strong>https://pinksoul.us</strong> (the "Site").
  </p>

  <h2>1. Information We Collect</h2>
  <ul>
    <li>
      <strong>Account Information:</strong> Name, email address, password,
      shipping address, and phone number.
    </li>
    <li>
      <strong>Order & Payment Information:</strong> Items purchased, billing
      address, and payment details (processed securely via Stripe; we do not
      store full credit card numbers).
    </li>
    <li>
      <strong>Usage Data:</strong> IP address, browser type, pages visited, and
      actions on the site.
    </li>
  </ul>

  <h2>2. How We Use Your Information</h2>
  <ul>
    <li>To create and manage your account</li>
    <li>To process orders and payments</li>
    <li>To provide customer service</li>
    <li>
      To send order updates, promotions, or newsletters (you can opt out
      anytime)
    </li>
    <li>To improve our website and services</li>
  </ul>

  <h2>3. Sharing Your Information</h2>
  <p>
    We do not sell or rent your personal information. We may share information
    with third parties only in the following cases:
  </p>
  <ul>
    <li>With Stripe for secure payment processing</li>
    <li>
      With service providers assisting in operations (e.g., shipping, email
      marketing)
    </li>
    <li>To comply with legal obligations</li>
  </ul>

  <h2>4. Your Rights</h2>
  <p>
    You have the right to access, update, or delete your personal information.
    You may do so by logging into your account or contacting us at
    <a href="mailto:support@pinksoul.us">support&#64;pinksoul.us</a>.
  </p>

  <h2>5. Cookies</h2>
  <p>
    We use cookies to enhance your shopping experience. You can disable cookies
    in your browser settings, but this may affect site functionality.
  </p>

  <h2>6. Data Security</h2>
  <p>
    We implement reasonable security measures to protect your information.
    However, no online transmission is 100% secure.
  </p>

  <h2>7. Changes to This Policy</h2>
  <p>
    We may update this Privacy Policy at any time. Changes will be posted on
    this page with a new "Last Updated" date.
  </p>

  <h2>8. Contact Us</h2>
  <p>
    If you have any questions, please contact us at
    <a href="mailto:support@pinksoul.us">support&#64;pinksoul.us</a>.
  </p>
</article>
